import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { MenuItem, composeRenderProps } from 'react-aria-components';
import { twMerge } from '../../utils/twMerge.js';
export const ActionMenuItem = forwardRef(function ActionMenuItem(props, forwardedRef) {
    return (_jsx(MenuItem, { ...props, ref: forwardedRef, className: composeRenderProps(props.className, (className) => twMerge('ppl-ActionMenuItem mx-1 flex cursor-pointer flex-row items-center gap-2 whitespace-nowrap rounded px-2 py-1 text-heading-sm text-default outline outline-1 -outline-offset-0 outline-transparent transition-[box-shadow,border-color,outline]', 
        // hover states
        'hover:bg-default-subdued-hover', 
        // selected states
        'selected:bg-accent-subdued selected:hover:bg-accent-subdued-hover selected:focus-visible:bg-accent-subdued', 
        // pressed states
        'pressed:bg-accent-subdued pressed:hover:bg-accent-subdued-hover pressed:focus-visible:bg-accent-subdued', 
        // focus visible states
        'focus-visible:outline-accent-bold focus-visible:ring focus-visible:ring-accent/[.38] focus-visible:ring-offset-1', 
        // disabled states
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-40', 
        // custom classes
        className)) }));
});
//# sourceMappingURL=ActionMenuItem.js.map